import { Injectable, inject } from '@angular/core';
import { CompanyApiService } from '@api-new/companyservice';
import { environment } from '@environments/environment';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/models/app-state.model';
import { AnalyticsService } from '@shared/services/analytics.service';
import { getSignUpBranding, getSignUpBrandingFailure, getSignUpBrandingSuccess } from '@shared/store/sign-up/branding/branding.actions';
import { selectSignUpBrandingReferralCode } from '@shared/store/sign-up/branding/branding.selectors';
import { applySignUpBrandingColors } from '@shared/store/sign-up/branding/utils/apply-sign-up-branding-colors';
import { getBrandingDomain } from '@shared/utils/get-branding-domain';
import { tap } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class SignUpBrandingEffects {
  private readonly companyApiService = inject(CompanyApiService);
  private readonly actions$ = inject(Actions);
  private readonly store: Store<AppState> = inject(Store);
  private readonly analyticsService = inject(AnalyticsService);

  getBranding = createEffect(() =>
    this.actions$.pipe(
      ofType(getSignUpBranding),
      withLatestFrom(this.store.select(selectSignUpBrandingReferralCode)),
      switchMap(([_, referralCode]) => {
        const referral = referralCode ?? environment.mobileApp?.referralCode;
        return this.companyApiService.HTTP_CP_LoadSignUpBranding({
          clientPortalDomain: referral == null ? getBrandingDomain() : undefined,
          referralCode: referral,
        });
      }),
      map((branding) => getSignUpBrandingSuccess({ branding })),
      catchError((error) => of(getSignUpBrandingFailure({ error }))),
    ),
  );

  getBrandingSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getSignUpBrandingSuccess),
        tap(({ branding }) => {
          applySignUpBrandingColors(branding.ctaBackgroundColor);
        }),
      ),
    { dispatch: false },
  );
}
